import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/pages/layout'
import caseRoute from './case'
import information from './information'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'layout',
      component: Layout,
      children: [
        {
          path: '/',
          name: 'home',
          component: () => import('@/pages/home')
        },
        {
          path: '/product',
          name: 'product',
          component: () => import('@/pages/product')
        },
        {
          path: '/technology',
          name: 'technology',
          component: () => import('@/pages/technology')
        },
        {
          path: '/planlife',
          name: 'planlife',
          component: () => import('@/pages/planlife')
        }, {
          path: '/planindustry',
          name: 'planindustry',
          component: () => import('@/pages/planindustry')
        }, {
          path: '/planculture',
          name: 'planculture',
          component: () => import('@/pages/planculture')
        },
        {
          path: '/about',
          name: 'about',
          component: () => import('@/pages/about')
        },
        caseRoute,
        information
      ]
    }
  ]
})

// let queue = []

router.afterEach((to, from) => {
  if (to.query.id) {
    let target = document.querySelector('#' + to.query.id)
    if (!target) {
      setTimeout(() => {
        target = document.querySelector('#' + to.query.id)
        target ? you(target) : window.scrollTo(0, 0)
      }, 100)
    } else {
      you(target)
    }
  } else {
    setTimeout(() => {
      you()
    }, 16)
  }
  //  || !~queue.indexOf(to.fullPath)
  // if (queue.length === 2) {
  //   queue.shift()
  // }
  // queue.push(to.fullPath)

  function you (target) {
    if (target) {
      let node = target
      let top = 0
      while (node && node !== document.documentElement && node !== document.body) {
        top += node.offsetTop
        node = node.offsetParent
      }
      setTimeout(() => {
        window.skip = true
        window.scrollTo(0, top - 65)
      })
    } else {
      console.log('???')
      window.scrollTo(0, 0)
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js